// Pure round-1 pairing logic (no I/O) — unit-testable under node --test.

// Standard golf bracket seeding as [a, b] pairs: 1↔N, 2↔(N-1), … (best plays
// worst in Round 1). `ids` is in qualifying-score order. Odd count → the
// middle/last team gets a bye (b === null).
export function snake1vN(ids) {
  const a = (ids || []).slice()
  const pairs = []
  while (a.length >= 2) pairs.push([a.shift(), a.pop()])
  if (a.length) pairs.push([a[0], null])
  return pairs
}

// MEMBER-AWARE Round-1 pairing. No Member team plays another Member team in
// round 1 — members are paired against non-members (best member vs worst
// non-member, 1↔N spirit). If a flight has MORE members than non-members, the
// unavoidable member-vs-member matches are MINIMIZED (each non-member absorbs
// one member first, then leftover members pair among themselves). A flight with
// no members (or no non-members) falls back to standard 1↔N — unchanged. After
// round 1 there is no restriction (normal bracket advancement).
//
// `flightTeams` is the flight's teams map, used to read team.info.member.
// Returns [[a, b|null], …].
export function memberAwarePairs(teamIds, flightTeams) {
  if (!teamIds || teamIds.length === 0) return []
  const isMem = (tid) => flightTeams?.[tid]?.info?.member === true
  const members = teamIds.filter(isMem)
  const nonMembers = teamIds.filter((tid) => !isMem(tid))
  if (members.length === 0 || nonMembers.length === 0) return snake1vN(teamIds)
  const mem = members.slice()              // best-first (qualifying order)
  const non = nonMembers.slice().reverse() // worst-first → best member vs worst non-member
  const pairs = []
  while (mem.length && non.length) pairs.push([mem.shift(), non.shift()])
  for (const p of snake1vN(mem)) pairs.push(p)           // leftover members: minimized member-vs-member
  for (const p of snake1vN(non.reverse())) pairs.push(p) // leftover non-members: unrestricted
  return pairs
}
